import { format } from 'date-fns';

import { DateBadgeProps } from './date-badge.component';

interface ViewProps {
    date?: string;
    time?: string;
}

const useDateBadge = (props: DateBadgeProps): ViewProps => {
    const date = props.date ? format(new Date(props.date), 'dd/MM/yyyy') : 'Unknown';
    const time = props.displayTime && props.date ? format(new Date(props.date), '• HH:mm') : 'Unknown';
    return {
        date,
        time
    };
};

export default useDateBadge;
